
import styles from './NewZoneScreen.module.css';
import helpers from '../../helpers.js';
import {useState, useContext, useCallback, useEffect, useRef, Fragment} from 'react';
import { useLocation} from "react-router-dom"; //packages

import { UserContext } from '../../UserContext.js';
import { GoogleMap, useJsApiLoader, DrawingManager, Polygon, Marker } from '@react-google-maps/api';

import ScreenHeader from "../ScreenHeader.js";
import Module from "../Module.js";
import TextInput from "../TextInput.js";
import Selector from "../../components/Selector";
import Checkbox from '../Checkbox.js';

import Button from "../Button.js";
import FAQ from "../support/FAQ.js";

import mapStyle from '../../assets/MapStyle.js';
import { GOOGLE_MAPS_LOADER_OPTIONS, IS_GOOGLE_MAPS_KEY_MISSING } from '../../config/googleMaps.js';
import iconZoneMarker from '../../assets/images/iconZoneMarker.png';
import iconMarkerBbb from '../../assets/images/iconMarkerBbb.png';
import iconMarkerWheat from '../../assets/images/iconMarkerWheat.png';
import iconMarkerCow from '../../assets/images/iconMarkerCow.png';
import iconMarkerHousing from '../../assets/images/iconMarkerHousing.png';

import ToggleSwitch from '../ToggleSwitch.js';
// The oversize-zone accident guard. See zoneAreaLimit.js for why 1,000 ha.
import {
  OVERSIZE_ZONE_MESSAGE,
  isZoneOversize,
  zoneAreaHectares,
} from './zoneAreaLimit';

const mapContainerStyle = {
  width: '100%',
  height: '500px',
  boxShadow: "0.2rem 0.2rem 0.5rem rgba(0, 0, 0, 0.1), 0px 4px 0.6rem rgba(0, 0, 0, 0.12)",
  borderRadius: "1.3rem"
};




//54.713801, -2.749613
const center = {
  lat: 54.713801,
  lng: -2.749613
};

const zonesArray = [
  {
    id: "",
    status: "delivered",
    deliveryDate: "",
    pincharBags: "",
    pelletcharBags: "",
    weight: "",
    volume: ""
  }
]

const soilTypeData = [
  { name: "-", value: "" },  // Default empty option
  { name: "Clay", value: "clay" },
  { name: "Sandy", value: "sandy" },
  { name: "Loamy", value: "loamy" },
  { name: "Other", value: "other" }
];

const fieldTypeData = [
  { name: "Arable", value: "arable" },
  { name: "Grassland", value: "grassland" },
  // { name: "Woodland", value: "woodland" },
  { name: "Other", value: "other" }
];


const zoneTypeOptions = [
  { name: "Land Application", value: "land", icon: "seedling" },
  { name: "Livestock Housing", value: "livestock", icon: "home" },
];

// what to render for each zone type (keeps UI + validation in one place)
const FORM_DEFS = {
  land: {
    fields: [
      { key: "zoneName", label: "Zone Name*", type: "text", required: true },
      { key: "zoneId", label: "Zone ID", type: "text" },

      { key: "fieldName", label: "Field Name", type: "text" },
      { key: "fieldId", label: "RPA/RLR Field Number", type: "text" },

      { key: "surfaceArea", label: "Surface Area (ha)*", type: "number" },
      { key: "fieldType", label: "Field Type*", type: "select", data: fieldTypeData, required: true },

      { key: "isCultivating", label: "This zone will be cultivated in the next 3 years", type: "checkbox" },
    ],
    // map front-end form keys to the request body for this type
    toRequestBody: (form, geo, userId) => ({
      _user: userId,
      zone_type: "land",
      zone_name: form.zoneName,
      field_name: form.fieldName || form.zoneName,
      field_id: form.fieldId || null,
      center_point: geo.centerPoint,
      polygon_shape: geo.polygonShape,
      surface_area: form.surfaceArea || null,
      field_type: form.fieldType || null,
      cultivated_in_next_3_years: !!form.isCultivating,
      marker_type: geo.markerType || null, // Include marker type for marker zones
    }),
  },

  livestock: {
    fields: [
      { key: "zoneName", label: "Zone Name*", type: "text", required: true },
      { key: "zoneId", label: "Zone ID", type: "text" },

      { key: "totalShedArea", label: "Total Shed Area (sqm)*", type: "number", required: true },
      { key: "numberOfSheds", label: "Number of Sheds*", type: "number", required: true },

      // optional extras you can uncomment when backend is ready:
      // { key: "species", label: "Species", type: "select", data: [{name:"Chickens", value:"chicken"}, {name:"Turkeys", value:"turkey"}, {name:"Other", value:"other"}] },
      // { key: "beddingType", label: "Bedding Type", type: "text" },
      // { key: "cycleLengthWeeks", label: "Cycle Length (weeks)", type: "number" },
    ],
    toRequestBody: (form, geo, userId) => ({
      _user: userId,
      zone_type: "livestock",
      zone_name: form.zoneName,
      field_name: form.zoneName, // not really a field in livestock context
      field_id: null,
      center_point: geo.centerPoint,
      polygon_shape: geo.polygonShape,
      surface_area: null, // keep separate from land ha
      marker_type: geo.markerType || null, // Include marker type for marker zones
      livestock_housing: {
        total_shed_area: form.totalShedArea ? Number(form.totalShedArea) : null,
        number_of_sheds: form.numberOfSheds ? Number(form.numberOfSheds) : null,
        // species: form.species || null,
        // bedding_type: form.beddingType || null,
        // cycle_length_weeks: form.cycleLengthWeeks ? Number(form.cycleLengthWeeks) : null,
      },
    }),
  },
};




function NewZoneScreen(props) {
 
  const { isLoaded, loadError } = useJsApiLoader(GOOGLE_MAPS_LOADER_OPTIONS);

const {user, setUser} = useContext(UserContext);
const [map, setMap] = useState(null);
const [allPolygons, setAllPolygons] = useState([]);
const [savedSurfaceArea, setSavedSurfaceArea] = useState(null);


const [drawZoneBoundary, setDrawZoneBoundary] = useState(true);// IF TRUE THEN DRAWING POLYGON RATHER THAN SETTING A CENTER POINT
const [zoneGeometry, setZoneGeometry] = useState({});
const markerRef = useRef(null); // Store single marker reference
const polygonRef = useRef(null);
const drawingManagerRef = useRef(null); // Store DrawingManager reference
const [hidePolygon, setHidePolygon] = useState(false); // 🔹 Toggle polygon visibility
const [existingZones, setExistingZones] = useState([]); // 🔹 Store previous zones from account
const [formData, setFormData] = useState({
  zoneType: "land",
  isCultivating: false,
  numberOfSheds: 1
});

// Marker type selection
const [selectedMarkerType, setSelectedMarkerType] = useState("bbb");
const [isDropdownOpen, setIsDropdownOpen] = useState(false);

const markerTypes = [
  { id: "bbb", name: "BBB", icon: iconMarkerBbb },
  { id: "housing", name: "Housing", icon: iconMarkerHousing },
  { id: "wheat", name: "Wheat", icon: iconMarkerWheat },
  { id: "dairy", name: "Dairy", icon: iconMarkerCow },
];

const location = useLocation();
const params = location.state || {};
// One shape-checked collection for both the onLoad fit-bounds and the render
// below. params.zones comes from router state, so a non-array (or a missing
// value) is possible; Array.isArray closes both the `.forEach` in onLoad and the
// `.map` in render against it in one place, which is what CodeRabbit asked for.
const zones = Array.isArray(params.zones) ? params.zones : [];
const [searchInput, setSearchInput] = useState("");


const handleChange = (formField, value) => {
  setFormData((prevData) => ({
    ...prevData,
    [formField]: formField === "surfaceArea" && value !== "" && isNaN(value) 
      ? prevData.surfaceArea // Keep previous valid value if input is invalid
      : value, // Otherwise, store new value
  }));
};

// Update marker icon when selectedMarkerType changes
useEffect(() => {
  if (markerRef.current && !drawZoneBoundary) {
    const selectedIcon = markerTypes.find(m => m.id === selectedMarkerType)?.icon || iconMarkerBbb;
    markerRef.current.setIcon({
      url: selectedIcon,
      scaledSize: new window.google.maps.Size(100, 100),
      anchor: new window.google.maps.Point(50, 90),
    });
    // Set animation to drop for the current marker (subtle effect)
    markerRef.current.setAnimation(window.google.maps.Animation.DROP);
  }
}, [selectedMarkerType, drawZoneBoundary]);

const onLoad = useCallback((mapInstance) => {
  setMap(mapInstance);
  setTimeout(() => {
    // `zones` is the shared shape-checked collection from the component body.
    // Each entry is also guarded, since a null in the array would throw at
    // `zone.center_point` here just as it would at `.map` in render.
    if (mapInstance && zones.length > 0) {
      // 🔹 Fit map to all zones on load
      const bounds = new window.google.maps.LatLngBounds();
      zones.forEach(zone => {
        if (zone?.center_point?.coordinates?.length === 2) {
          bounds.extend({
            lat: zone.center_point.coordinates[1],
            lng: zone.center_point.coordinates[0]
          });
        }
        if (zone?.polygon_shape?.coordinates?.length > 0) {
          zone.polygon_shape.coordinates[0].forEach(coord => {
            bounds.extend({ lat: coord[1], lng: coord[0] });
          });
        }
      });
      mapInstance.fitBounds(bounds);
    }
  }, 100)
}, []);

const onUnmount = useCallback((mapInstance) => {
  setMap(null);
}, []);

const getGeometryForSubmit = () => {
  let centerPoint = null;
  let polygonShape = null;
  let markerType = null;

  if (polygonRef.current) {
    const path = polygonRef.current.getPath();
    const coords = path.getArray().map(c => [c.lng(), c.lat()]);
    if (coords.length > 0) coords.push(coords[0]); // close ring
    polygonShape = { type: "Polygon", coordinates: [coords] };
    centerPoint = { type: "extrapolated", coordinates: [] }; // server computes centroid
  }

  if (markerRef.current && hidePolygon) {
    const pos = markerRef.current.getPosition();
    polygonShape = null;
    centerPoint = { type: "manually_set", coordinates: [pos.lng(), pos.lat()] };
    markerType = selectedMarkerType; // Include the selected marker type
  }

  return { centerPoint, polygonShape, markerType };
};


const handlePolygonEdit = (polygon) => {
  const path = polygon.getPath();
  const newCoordinates = path.getArray().map(latlng => ({
    lat: latlng.lat(),
    lng: latlng.lng()
  }));
  setFormData((prevData) => ({ ...prevData, surfaceArea: zoneAreaHectares(path) }));


  console.log("Polygon was edited:", newCoordinates);

  // Optional: Update state or save to DB
};

const onPolygonComplete = (polygon) => {
  // Clear old polygon or marker
  polygonRef.current?.setMap(null);
  markerRef.current?.setMap(null);

  // ✅ Store the new one
  polygonRef.current = polygon;

  

  // ✅ Make it editable and draggable
  polygon.setEditable(true);
  polygon.setDraggable(false);
 

  const path = polygon.getPath();

  // Reject before wiring any listeners or storing geometry: an oversize polygon
  // is thrown away rather than made editable, because making it editable is
  // what leaves a farmer clicking on the thing that freezes.
  if (isZoneOversize(zoneAreaHectares(path))) {
    polygon.setMap(null);
    polygonRef.current = null;
    alert(OVERSIZE_ZONE_MESSAGE);
    return;
  }

  // ➕ Store coordinates
   // Listen for polygon edits
  path.addListener("set_at", () => handlePolygonEdit(polygon));
  path.addListener("insert_at", () => handlePolygonEdit(polygon));
  path.addListener("remove_at", () => handlePolygonEdit(polygon));
  const coordinates = path.getArray().map(coord => [coord.lng(), coord.lat()]);
  setZoneGeometry({ polygon_shape: { type: "Polygon", coordinates: [coordinates] } });

  // ➕ Compute area
  setFormData((prevData) => ({ ...prevData, surfaceArea: zoneAreaHectares(path) }));

  // // Optional mouse cursor tweaks
  // polygon.addListener('mouseover', () => {
  //   map.setOptions({ draggableCursor: 'pointer' });
  // });
  // polygon.addListener('mouseout', () => {
  //   map.setOptions({ draggableCursor: 'crosshair' });
  // });

  // ❌ Remove this: polygonRef.current.push(polygon)

  // Right click to remove
  // window.google.maps.event.addListener(polygon, 'rightclick', () => {
  //   polygon.setMap(null);
  //   polygonRef.current = null;
  // });

  // Optional: listeners for edits
  window.google.maps.event.addListener(path, 'set_at', () => {
    console.log('Vertex moved');
  });
  window.google.maps.event.addListener(path, 'insert_at', () => {
    console.log('Vertex added');
  });

};

const onMarkerComplete = (newMarker) => {
  //🔹 Ensure only one marker exists at a time
  if (polygonRef.current || markerRef.current) {
    polygonRef.current?.setMap(null); // Remove previous polygon
    markerRef.current?.setMap(null); // Correctly remove the previous marker
  }

  markerRef.current = newMarker; // 🔹 Store the new marker reference
  setZoneGeometry({ 
    lat: newMarker.getPosition().lat(), 
    lng: newMarker.getPosition().lng() 
  });

  // Add drop animation to newly placed marker (subtle effect)
  newMarker.setAnimation(window.google.maps.Animation.DROP);

  // 🔹 Allow clicking on the marker to remove it
  newMarker.addListener('click', () => {
    newMarker.setMap(null);
    markerRef.current = null; // Clear marker reference
    setZoneGeometry({});
  });
};


// const togglePolygonDisplay = () => {
//   if (hidePolygon) {
//     polygonRef.current.setMap(map); // Remove polygon from map
//     markerRef.current?.setMap(null); // Show marker on map
//     markerRef.current = null; // Clear marker reference
//   } else {
//     console.log("HEEERE")
//     polygonRef.current?.setMap(null); // Show polygon on map
//   }
//   setHidePolygon(!hidePolygon);
// }

const togglePolygonDisplay = () => {
  if (!hidePolygon) {
    // 👉 Hiding polygon (switching to marker mode)
    if (formData.surfaceArea) {
      setSavedSurfaceArea(formData.surfaceArea); // save current polygon area
    }
    setFormData((prev) => ({ ...prev, surfaceArea: "" })); // reset in form
    polygonRef.current?.setMap(null);
  } else {
    // 👉 Showing polygon (switching back to polygon mode)
    if (savedSurfaceArea) {
      setFormData((prev) => ({ ...prev, surfaceArea: savedSurfaceArea }));
    }
    markerRef.current?.setMap(null); // Remove marker if it exists
    polygonRef.current?.setMap(map);
  }

  setHidePolygon(!hidePolygon);
};


const resetGeometry = () => {
  // 1) Cancel any in-progress sketch (before completion)
  const dm = drawingManagerRef.current;
  if (dm && window.google?.maps?.drawing) {
    // turn off drawing -> discards unfinished sketch
    dm.setDrawingMode(null);

    // restore the intended mode on the next tick
    setTimeout(() => {
      const mode = drawZoneBoundary
        ? window.google.maps.drawing.OverlayType.POLYGON
        : window.google.maps.drawing.OverlayType.MARKER;
      dm.setDrawingMode(mode);
    }, 0);
  }

  // 2) Remove any completed overlays we're tracking
  if (polygonRef.current) {
    // (optional) clear edit listeners to avoid leaks
    const path = polygonRef.current.getPath?.();
    if (path) {
      window.google.maps.event.clearInstanceListeners(path);
    }
    polygonRef.current.setMap(null);
    polygonRef.current = null;
  }

  if (markerRef.current) {
    window.google.maps.event.clearInstanceListeners(markerRef.current);
    markerRef.current.setMap(null);
    markerRef.current = null;
  }

  // 3) Reset UI state
  setAllPolygons([]);
  setZoneGeometry({});
  setSavedSurfaceArea(null);
  setFormData((prev) => ({ ...prev, surfaceArea: "" }));
}

const removeLastAction = () => {
  const polygon = polygonRef.current;
  if (polygon) {
    const path = polygon.getPath();
    if (path.getLength() > 1) {
      path.pop(); // Remove last vertex
    }
  }
};
const handleSubmit = async () => {
  try {
    if (!user?.details?.id) { alert("Session expired. Please log in again."); return; }

    const { centerPoint, polygonShape, markerType } = getGeometryForSubmit();
    if (!centerPoint && !polygonShape) {
      alert("Please add a polygon or marker to your zone"); return;
    }

    const def = FORM_DEFS[formData.zoneType];

    // required fields per type
    const missing = def.fields
      .filter(f => f.required)
      .filter(f => !formData[f.key] && formData[f.key] !== 0)
      .map(f => f.label);
    if (missing.length) {
      alert(`Missing: ${missing.join(", ")}`); return;
    }

    // extra land-only validation (your API enforces this too, but nice UX)
    if (formData.zoneType === "land" && !formData.fieldType) {
      alert("Please add field type"); return;
    }

    // The draw-time guard catches the polygon as completed; this catches one
    // grown past the cap afterwards by dragging a vertex. Reverting a drag
    // cleanly is not a cheap fix, so the gate lives here instead.
    if (isZoneOversize(formData.surfaceArea)) {
      alert(OVERSIZE_ZONE_MESSAGE); return;
    }

    // Build request body using the per-type mapper
    const requestBody = def.toRequestBody(
      formData,
      { centerPoint, polygonShape, markerType },
      user.details.id
    );

    const request = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.token,
      },
      body: JSON.stringify(requestBody),
    };

    const response = await fetch(user.backEndURL + "/zones", request);
    const json = await response.json();

    if (json.success) {
      props.goToScreen("zones");
    } else {
      console.error(json);
      alert(json.message || "Failed to create zone.");
    }
  } catch (err) {
    console.error("Error creating zone:", err);
    alert("Unexpected error. Please try again.");
  }
};



const zoomToAddress = async (address) => {
  if (!window.google || !map) return;

  const geocoder = new window.google.maps.Geocoder();
  
  geocoder.geocode({ address }, (results, status) => {
    if (status === "OK" && results[0]) {
      const location = results[0].geometry.location;
      map.setCenter(location);
      map.setZoom(15); // Or zoom level you want
    } else {
      console.error("Geocode failed:", status);
    }
  });
};


return(
  <div className={helpers.clx("mainWhiteContainerContent", props.screenTransitioning ? "mainWhiteContainerContentHidden" : "")}>
      <ScreenHeader name={"Add New Zone"} content={"Add, edit, and delete the zones you own. These are used to map biochar application to your land. Create zones using polygons (draw boundaries) or markers (set center points) for either land application or livestock housing. After drawing, you can edit polygon shapes by dragging the corner dots. Use the Reset button to clear and restart."}/>
      
      <div className={helpers.clx("contentGrid", styles.contentGrid)}>
        {/* <div className={styles.newZoneButtonContainer}>
          <Button name={"Add New Zone +"} onPress={() => props.goToScreen("/new-zone")} color={"Coal"}/>
        </div> */}
        <Module icon={'\uf5cb'} name={"Zone Geometry"} spanColumn={24} height={"100%"}>
          <div className={styles.geometrySettingsContainer}>
            <div className={styles.backButtonContainer}>
                 <Button name={"Back to Plans"} onPress={() => props.goToScreen("zones")} color={"Coal"} customStyle={{height: "6px !important"}}/>
            </div>        
         
            <div className={styles.resetButtonContainer}>
              <div className={styles.toggleSwitchContainer}>
              Draw Zone Boundary
              <ToggleSwitch toggled={!drawZoneBoundary} onPress={() => {togglePolygonDisplay();setDrawZoneBoundary(!drawZoneBoundary);}}/>
              Set Zone Center
              </div>
              <div className={styles.resetButton}>
                <Button name={"Reset ↺"} onPress={() => resetGeometry({})} color={"Error"} customStyle={{height: "6px !important"}}/>
              </div>
              <div className={styles.selectorContainer}>
                <Selector
                  name="Zone Type"
                  value={formData.zoneType}
                  onChange={(v) => setFormData((p) => ({ ...p, zoneType: v }))}
                  data={zoneTypeOptions}
                />
              </div>
              
              {/* <Button name={"⌫"} onPress={() => removeLastAction()} color={"Coal"}/> */}

            </div>
          </div>
          { (loadError || IS_GOOGLE_MAPS_KEY_MISSING) ? (
            <div style={{ ...mapContainerStyle, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '1rem' }}>
              The map couldn’t be loaded. Please refresh the page or try again shortly.
            </div>
          ) : isLoaded ?
            <GoogleMap
              mapContainerStyle={mapContainerStyle}
              center={center}
              zoom={8}
              onLoad={onLoad}
              onUnmount={onUnmount}
              options={{
                styles: mapStyle,
                disableDefaultUI: true,
                draggable: true,
                zoomControl: true,
                scrollwheel: true,
                disableDoubleClickZoom: true,
                // draggableCursor: "crosshair",
                mapTypeId: "hybrid",
                keyboardShortcuts: false, // disables keyboard shortcuts AND hides the button
                fullscreenControl: false, // optional: hides fullscreen button
                mapTypeControl: false,    // optional: hides map type buttons
              }}
            > 
             <div className={styles.searchContainer}>
                  <TextInput
  placeholder="Enter postcode or address..."
  value={searchInput}
  onChange={setSearchInput}
  name=""
  onKeyDown={(e) => {
    if (e.key === 'Enter') {
      zoomToAddress(searchInput);
    }
  }}
/>
                  <div className={styles.searchButtonContainer}>
                    <Button name="Go" onPress={() => zoomToAddress(searchInput)} color="Coal" />
                  </div>
                </div>
              <div>

              </div>

               <DrawingManager
                key={selectedMarkerType} // Force re-render when marker type changes
                onLoad={(dm) => { drawingManagerRef.current = dm; }}
                drawingMode={!drawZoneBoundary ? "marker" : polygonRef.current === null ? "polygon" : null} // Force the polygon drawing tool to be active
                onPolygonComplete={onPolygonComplete}
                onMarkerComplete={onMarkerComplete}
                options={{
                  drawingControl: false,
                  polygonOptions: {
                    strokeColor:  '#c8ff00ff', //'#34B61F',      // border) color
                    strokeWeight: 2,             // Stroke width in pixels
                    strokePattern: [10, 10],     // 10px dash, 10px gap                  strokeOpacity: 0.8,          // Stroke opacity (transparency)
                    fillColor: '#B0E000',        // fill color
                    fillOpacity: 0.25,           // Fill opacity (transparency)
                    editable: true,
                    draggable: true,
                  },
                  markerOptions: { // 🔹 Custom marker icon setup
                    icon: {
                      url: markerTypes.find(m => m.id === selectedMarkerType)?.icon || iconMarkerBbb, // 🔹 Use selected marker type
                      scaledSize: new window.google.maps.Size(100, 100), // 🔹 Adjust size
                      anchor: new window.google.maps.Point(50, 90), // 🔹 Adjust anchor point (so it sits correctly)
                    },
                  }
                }}
                
              />
              
              {/* Marker Type Selection Overlay - only show when in marker mode */}
              {!drawZoneBoundary && (
                <div className={styles.markerTypeOverlay}>
                  <div 
                    className={styles.markerTypeHeader}
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                  >
                    <div className={styles.markerTypeTitle}>Marker Type</div>
                    <span className={helpers.clx(
                      styles.markerTypeChevron,
                      isDropdownOpen ? styles.markerTypeChevronOpen : ""
                    )}>
                      &#xf078;
                    </span>
                  </div>
                  
                  {isDropdownOpen && (
                    <div className={styles.markerTypeDropdown}>
                      {markerTypes.map((markerType) => (
                        <div
                          key={markerType.id}
                          className={helpers.clx(
                            styles.markerTypeOption,
                            selectedMarkerType === markerType.id ? styles.markerTypeOptionSelected : ""
                          )}
                          onClick={() => {
                            setSelectedMarkerType(markerType.id);
                            setIsDropdownOpen(false);
                          }}
                        >
                          <img 
                            src={markerType.icon} 
                            alt={markerType.name}
                            className={styles.markerTypeIcon}
                          />
                          <span className={styles.markerTypeName}>{markerType.name}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
              
              {/* Render existing zones */}
              {zones.map((zone, index) => {
                if (zone?.polygon_shape?.coordinates?.length > 0) {
                  // Convert GeoJSON format to Google Maps Polygon format
                  const polygonPaths = zone.polygon_shape.coordinates[0].map(coord => ({
                    lat: coord[1],  // GeoJSON stores [lng, lat], Google Maps uses {lat, lng}
                    lng: coord[0]
                  }));

                  return (
                    <Fragment key={`zone-${zone._id}`}>
                      {/* Polygon */}
                       <Polygon
                        key={`polygon-${zone._id}`}
                        paths={polygonPaths}
                        options={{
                          fillColor: "#B0E000", // ✅ Your requested color
                          fillOpacity: 0.14, // 🔹 Adjust opacity for unselected
                          strokeColor: "#B0E000",
                          strokeOpacity: 0.5, 
                          strokeWeight: 2,
                          clickable: true,
                          editable: false,
                          draggable: false,
                        }}
                      />
                      
                      {/* Polygon Label */}
                      <Marker
                        key={`polygon-label-${zone._id}`}
                        position={polygonPaths[0]} // First coordinate as label anchor
                        icon={{
                          url: "", // ✅ Hide default icon
                          scaledSize: new window.google.maps.Size(1, 1),
                          labelOrigin: new window.google.maps.Point(1, 15) // ✅ Adjust label position
                        }}
                        label={{
                          text: zone.zone_name, // ✅ Display the zone name
                          color: "white",
                          fontSize: "14px",
                          fontWeight: "bold",
                          className: styles.polygonLabel
                        }}
                        style={{
                          width: "100px",
                          height: "100px",
                          background: "red",
                        }}
                      />
                    </Fragment>
                  );
                } else if (zone?.center_point?.coordinates?.length === 2) {
                  return (
                    <Fragment key={`zone-${zone._id}`}>
                      {/* Marker */}
                      <Marker
                        key={`marker-${zone._id}`}
                        position={{
                          lat: zone.center_point.coordinates[1], 
                          lng: zone.center_point.coordinates[0],
                        }}
                        icon={{
                          url: helpers.getMarkerIcon(zone.marker_type), // Use zone's stored marker type
                          scaledSize: new window.google.maps.Size(80, 80),
                          anchor: new window.google.maps.Point(32.5, 65),
                          labelOrigin: new window.google.maps.Point(40, 90) // ✅ Moves label BELOW the icon
                        }}
                        options={{
                          opacity: 0.7 // Reduced opacity for existing zones
                        }}
                        label={{
                          text: zone.zone_name,
                          color: "white",
                          fontSize: "14px",
                          fontWeight: "bold",
                          className: styles.markerLabel
                        }}
                      />
                    </Fragment>
                  );
                }
                return null;
              })}
            </GoogleMap>
          : null
          }
        </Module>
       <Module icon={"pencil"} name={"Zone Details"} spanColumn={24} spanRow={1} height={"100%"}>
        <div className={styles.contentWrapper}>

          {FORM_DEFS[formData.zoneType].fields.reduce((rows, field, i, arr) => {
            if (i % 2 === 0) {
              // start of a new row -> slice out two fields
              const pair = arr.slice(i, i + 2);

              rows.push(
                <div key={`row-${i}`} className={styles.detailsRow}>
                  {pair.map((f) => {
                    if (f.type === "select") {
                      return (
                        <Selector
                          key={f.key}
                          name={f.label}
                          value={formData[f.key]}
                          onChange={(v) => handleChange(f.key, v)}
                          labelStyle="top"
                          data={f.data}
                        />
                      );
                    }
                    if (f.type === "checkbox") {
                      return (
                        <div key={f.key} className={styles.checkBoxContainer}>
                          <Checkbox
                            text={f.label}
                            checked={!!formData[f.key]}
                            onPress={() => handleChange(f.key, !formData[f.key])}
                          />
                        </div>
                      );
                    }
                    return (
                      <TextInput
                        key={f.key}
                        name={f.label}
                        value={formData[f.key] ?? ""}
                        onChange={(v) => handleChange(f.key, v)}
                        labelStyle="top"
                        placeholder={`Enter ${f.label}`}
                        type={f.type === "number" ? "number" : "text"}
                      />
                    );
                  })}
                </div>
              );
            }
            return rows;
          }, [])}

          <div className={styles.buttonRow}>
            <Button onPress={() => props.goToScreen("zones")} name={"Cancel"} color="Coal"/>
            <Button onPress={() => handleSubmit()} name={"Save Zone"} color="Leaf"/>
          </div>
        </div>
      </Module>

        {/* <Button onPress={() => setAllPolygons([])}/> */}
        {/* <Module name={"User Details"} spanColumn={10} spanRow={2} height={"100%"}>
          <div/>
        </Module> */}
      </div>
    </div>
  )

}

export default NewZoneScreen;
